module.exports = __webpack_public_path__ + "img/workorder_nr2_2.9cdee808.png";